import Calendar from './calendar/fr_FR';
import DatePicker from './date-picker/fr_FR';
import Pagination from './pagination/fr_FR';
import TimePicker from './time-picker/fr_FR';

export default {
  locale: 'fr',
  Pagination,
  DatePicker,
  TimePicker,
  Calendar,
  Table: {
    filterTitle: 'Filtrer',
    filterConfirm: 'OK',
    filterReset: 'RÃ©initialiser',
    emptyText: 'Aucune donnÃ©e',
  },
  Modal: {
    okText: 'OK',
    cancelText: 'Annuler',
    justOkText: 'OK',
  },
  Popconfirm: {
    okText: 'OK',
    cancelText: 'Annuler',
  },
  Transfer: {
    notFoundContent: 'Pas de rÃ©sultat',
    searchPlaceholder: 'Recherche',
    itemUnit: 'Ã©lÃ©ment',
    itemsUnit: 'Ã©lÃ©ments',
  },
  Select: {
    notFoundContent: 'Pas de rÃ©sultat',
  },
};
